import React from 'react';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { SEOMetaTags } from '../../components/shared/SEOMetaTags';

// Icônes pertinentes
import { Trophy, Award, Medal, Crown, Star, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

// --- Données des Lauréats ---
const laureatsList = [
    {
        name: "DR MOKGWEETSI ERIC KEABETSWE MASISI",
        title: "Prix pan-africain des meilleures pratiques managériales innovantes 2020",
        year: "2020",
        description: "Lauréat du prix pan-africain des meilleures pratiques managériales innovantes.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2022/03/DR-MOKGWEETSI.jpeg",
        category: "Management & Innovation"
    },
    {
        name: "Dr ALLAH-RIDY KONE",
        title: "Prix sous régional de l'intégrité 2021",
        year: "2021",
        description: "Lauréat du prix sous régional de l'intégrité.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2022/02/photo-dr-allah-ridy-en-tauge-new-fin-1.jpg",
        category: "Intégrité & Éthique"
    },
    {
        name: "M. FORTUNATO OFA MBO NCHAMA",
        title: "Prix panafricain des meilleures pratiques managériales 2020",
        year: "2020",
        description: "Président de la BDEAC, lauréat du prix panafricain des meilleures pratiques managériales.",
        imageUrl: "https://www.lenouveaugabon.com/media/k2/items/cache/88dafd0d4fa4e6c5d28c7ff83f4edc54_L.jpg",
        category: "Management & Finance"
    },
    {
        name: "JEAN BRUNO TAGNE",
        title: "Prix sous régional du journalisme 2020",
        year: "2020",
        description: "Lauréat du prix sous régional du journalisme.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/JEAN-BRUNO-TAGNE.jpeg",
        category: "Journalisme & Médias"
    },
    {
        name: "CHARLES EBUNE NDOH",
        title: "Prix sous régional du journalisme 2020",
        year: "2020",
        description: "Lauréat du prix sous régional du journalisme.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/CHARLES-EBUNE-NDOH.jpeg",
        category: "Journalisme & Médias"
    },
    {
        name: "M. Joseph LE",
        title: "Prix panafricain des meilleures pratiques managériales 2019",
        year: "2019",
        description: "Ministre de la Fonction Publique du Cameroun, lauréat du prix panafricain des meilleures pratiques managériales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/Joseph-Le-1.jpeg",
        category: "Administration Publique"
    },
    {
        name: "M. Clément ATANGANA",
        title: "Prix sous régional des meilleures pratiques judiciaires innovantes 2019",
        year: "2019",
        description: "Président du Conseil Constitutionnel du Cameroun, lauréat du prix sous régional des meilleures pratiques judiciaires innovantes.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/photo-disc-pcc.jpg",
        category: "Justice & Droit"
    },
    {
        name: "M. Josué YOUMBA",
        title: "Prix sous régional des meilleures pratiques managériales et de l'innovation 2019",
        year: "2019",
        description: "DG Autorité Portuaire Nationale, lauréat du prix sous régional des meilleures pratiques managériales et de l'innovation.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/Youmba-1024x684.jpeg",
        category: "Management & Transport"
    },
    {
        name: "M. ALAMINE OUSMANE MEY",
        title: "Prix de l'excellence managériale 2015",
        year: "2015",
        description: "Ministre des finances du Cameroun, lauréat du prix de l'excellence managériale.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/ALAMINE.jpeg",
        category: "Finance & Management"
    },
    {
        name: "Mme CELESTINE KETCHA COURTES",
        title: "Prix de l'excellence managériale et de leadership féminin 2014",
        year: "2014",
        description: "Lauréate du prix de l'excellence managériale et de leadership féminin.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/CELESTINE-KETCHA-COURTES.jpeg",
        category: "Leadership Féminin"
    },
    {
        name: "DANGOTE CEMENT",
        title: "Prix best cement of year 2015",
        year: "2015",
        description: "Le prix best cement of year.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/DANGOTE-CEMENT.jpeg",
        category: "Industrie & Entreprise"
    },
    {
        name: "Pr JEAN LOUIS ESSAME OYONO",
        title: "Prix sous régional de l'excellence managériale 2017",
        year: "2017",
        description: "Directeur IMPM – Cameroun, lauréat du prix sous régional de l'excellence managériale.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/JEAN-LOUIS-ESSAME-OYONO.jpeg",
        category: "Éducation & Management"
    },
    {
        name: "Dr CONSTANT ROGER AYENENGOYE",
        title: "Prix sous régional de l'excellence managériale 2017",
        year: "2017",
        description: "Lauréat du prix sous régional de l'excellence managériale (GABON).",
        imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTM4-5Vx5x_P86jkR_0k5i_CDPw2vyOq4Wnxg&s",
        category: "Management & Innovation"
    },
    {
        name: "CENTRE MÉDICAL LA CATHÉDRALE",
        title: "Prix Sous-Régional de l'Excellence et de l'Innovation Médicale",
        year: "2022",
        description: "Lauréat du Prix Sous-Régional de l'Excellence et de l'Innovation Médicale.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2022/09/CENTRE-MEDICAL-LA-CATHEDRALE-1024x683.jpeg",
        category: "Santé & Innovation"
    },
    {
        name: "S.E WILLIAM ETEKI MBOUMOUA",
        title: "Prix de l'intégrité 2013",
        year: "2013",
        description: "Ancien secrétaire général UDEAC, lauréat du prix de l'intégrité.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/WILLIAM-ETEKI-MBOUMOUA.jpeg",
        category: "Intégrité & Éthique"
    },
    {
        name: "Mme BARBARA ALVINE ELEMVA",
        title: "Prix sous régional de l'excellence et de leadership féminin 2019",
        year: "2019",
        description: "Prix sous régional de l'excellence et de leadership féminin.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/Babara-Alvine-Elemva.jpeg",
        category: "Leadership Féminin"
    },
    {
        name: "M. DIVINE MBAMOME NKENDONG",
        title: "Prix de l'excellence managériale et de leadership jeunesse 2017",
        year: "2017",
        description: "Lauréat du prix de l'excellence managériale et de leadership jeunesse.",
        imageUrl: "https://www.cameroon-tribune.cm//administrateur/photo/normal_a88ab3a.jpg",
        category: "Leadership Jeunesse"
    },
    {
        name: "M. Félix TSHISEKEDI",
        title: "Prix panafricain des meilleures pratiques managériales 2020",
        year: "2020",
        description: "Lauréat du prix panafricain des meilleures pratiques managériales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/felic-tsh.jpg",
        category: "Management Politique"
    },
    {
        name: "M. ALI BONGO ONDIMBA",
        title: "Prix sous régional de l'excellence managériale 2020",
        year: "2020",
        description: "Lauréat du prix sous régional de l'excellence managériale.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/bongo-ali.jpeg",
        category: "Management Politique"
    },
    {
        name: "M. ISSOUFOU MAHAMADOU",
        title: "Prix pan-africain des meilleures pratiques managériales 2013",
        year: "2013",
        description: "Lauréat du prix pan-africain des meilleures pratiques managériales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/pdt-issoufou.jpeg",
        category: "Management Politique"
    },
    {
        name: "M. Marcel MBOA",
        title: "Prix sous régional des meilleures pratiques managériales 2017",
        year: "2017",
        description: "Directeur BEAC – Ouest/Cameroun, lauréat du prix sous régional des meilleures pratiques managériales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/foto-ens-n.2.jpg",
        category: "Management & Finance"
    },
    {
        name: "Dr Euloge YIAGNIGNI MFOPOU",
        title: "Prix sous régional des meilleures pratiques médicales 2019",
        year: "2019",
        description: "Lauréat du prix sous régional des meilleures pratiques médicales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/euloge.jpeg",
        category: "Santé & Innovation"
    },
    {
        name: "Pr Maurice Aurélien SOSSO",
        title: "Prix sous régional des meilleures pratiques managériales 2019",
        year: "2019",
        description: "Recteur de l'Université de Yaoundé I, lauréat du prix sous régional des meilleures pratiques managériales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/photo-uy.jpg",
        category: "Éducation & Management"
    },
    {
        name: "Pr Alexis NDJOLO",
        title: "Prix sous régional de l'excellence managériale 2017",
        year: "2017",
        description: "Directeur du CIRCB – Cameroun, lauréat du prix sous régional de l'excellence managériale.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/remise-dist-pm-d-circb.jpg",
        category: "Management & Innovation"
    },
    {
        name: "M.ELOUNDOU AYISSI",
        title: "Prix sous régional des meilleures pratiques communales 2019",
        year: "2019",
        description: "Lauréat du prix sous régional des meilleures pratiques communales.",
        imageUrl: "https://ice-inter.com/wp-content/uploads/2021/03/EloudouAyissi-1024x767.jpeg",
        category: "Administration Publique"
    }
];

// Catégories disponibles
const categories = ["Tous", "Management & Innovation", "Intégrité & Éthique", "Management & Finance", "Journalisme & Médias", "Administration Publique", "Justice & Droit", "Management & Transport", "Finance & Management", "Leadership Féminin", "Industrie & Entreprise", "Éducation & Management", "Santé & Innovation", "Leadership Jeunesse", "Management Politique"];

export const LaureatsPage: React.FC = () => {
    const [selectedCategory, setSelectedCategory] = React.useState("Tous");

    const filteredLaureats = selectedCategory === "Tous"
        ? laureatsList
        : laureatsList.filter(laureat => laureat.category === selectedCategory);

    return (
        <PublicLayout>
            <SEOMetaTags
                title="Nos Lauréats - International Committee of Excellence (ICE)"
                description="Découvrez les personnalités exceptionnelles qui ont été honorées par les distinctions de l'ICE pour leur contribution à l'excellence africaine."
            />

            <div className="bg-[#0d1321] text-white">

                {/* --- Section Héros --- */}
                <section
                    className="relative py-32 md:py-48 flex items-center justify-center text-center"
                    style={{
                        backgroundImage: 'url(https://ice-inter.com/wp-content/uploads/2023/10/3bfb0309-52f8-4ad0-85e0-c43819d63c9e-1.jpg)',
                        backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed'
                    }}
                >
                    <div className="absolute inset-0 bg-[#0d1321]/80 backdrop-blur-sm"></div>
                    <div className="relative z-10 container mx-auto px-4">
                        <div className="flex justify-center mb-6">
                            <div className="text-[#d2ab6a] w-20 h-20 flex items-center justify-center">
                                <Trophy className="w-full h-full" />
                            </div>
                        </div>
                        <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
                            Galerie des <span className="text-[#d2ab6a]">Lauréats</span>
                        </h1>
                        <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto">
                            Découvrez les personnalités exceptionnelles qui incarnent l'excellence africaine et inspirent les générations futures.
                        </p>
                    </div>
                </section>

                {/* --- Section Filtres --- */}
                <section className="py-12 bg-white/5">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap justify-center gap-4 mb-8">
                            {categories.map((category) => (
                                <button
                                    key={category}
                                    onClick={() => setSelectedCategory(category)}
                                    className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 ${
                                        selectedCategory === category
                                            ? 'bg-[#d2ab6a] text-white shadow-lg'
                                            : 'bg-white/10 text-white/80 hover:bg-white/20 hover:text-white'
                                    }`}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>
                    </div>
                </section>

                {/* --- Section Grille des Lauréats --- */}
                <section className="py-20">
                    <div className="container mx-auto px-4">
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {filteredLaureats.map((laureat, index) => (
                                <div
                                    key={index}
                                    className="group bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 transition-all duration-300 hover:border-[#d2ab6a]/50 hover:bg-white/10 transform hover:-translate-y-2"
                                >
                                    <div className="relative h-64 bg-white/5">
                                        <img
                                            src={laureat.imageUrl}
                                            alt={`Portrait de ${laureat.name}`}
                                            className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-105"
                                            onError={(e) => {
                                                const target = e.target as HTMLImageElement;
                                                target.onerror = null;
                                                target.src = 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?fit=crop&w=400&q=80';
                                            }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#0d1321]/60 via-transparent"></div>
                                        <div className="absolute top-4 right-4">
                                            <div className="bg-[#d2ab6a] text-white px-3 py-1 rounded-full text-sm font-bold">
                                                {laureat.year}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-6">
                                        <div className="flex items-center justify-between mb-3">
                                            <h3 className="text-xl font-bold text-white">{laureat.name}</h3>
                                            <div className="text-[#d2ab6a] w-8 h-8 flex items-center justify-center">
                                                <Crown className="w-full h-full" />
                                            </div>
                                        </div>
                                        <div className="text-[#d2ab6a] font-semibold text-sm mb-3 bg-[#d2ab6a]/10 px-3 py-1 rounded-full inline-block">
                                            {laureat.title}
                                        </div>
                                        <p className="text-white/70 text-sm leading-relaxed mb-4">
                                            {laureat.description}
                                        </p>
                                        <div className="flex items-center justify-between">
                                            <span className="text-xs text-white/50 bg-white/10 px-2 py-1 rounded-full">
                                                {laureat.category}
                                            </span>
                                            <Link
                                                to="#"
                                                className="text-[#d2ab6a] hover:text-white text-sm font-medium transition-colors duration-300"
                                            >
                                                En savoir plus →
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {filteredLaureats.length === 0 && (
                            <div className="text-center py-12">
                                <p className="text-white/60 text-lg">Aucun lauréat trouvé dans cette catégorie.</p>
                            </div>
                        )}
                    </div>
                </section>

                {/* --- Section Statistiques --- */}
                <section className="py-20 bg-white/5">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-16">
                            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                                L'Impact de nos <span className="text-[#d2ab6a]">Lauréats</span>
                            </h2>
                        </div>

                        <div className="grid md:grid-cols-4 gap-8 text-center">
                            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                    <Users className="w-full h-full" />
                                </div>
                                <div className="text-4xl font-bold text-[#d2ab6a] mb-2">25</div>
                                <p className="text-white/70">Lauréats</p>
                            </div>

                            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                    <Trophy className="w-full h-full" />
                                </div>
                                <div className="text-4xl font-bold text-[#d2ab6a] mb-2">24</div>
                                <p className="text-white/70">Distinctions</p>
                            </div>

                            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                    <Award className="w-full h-full" />
                                </div>
                                <div className="text-4xl font-bold text-[#d2ab6a] mb-2">20+</div>
                                <p className="text-white/70">Pays représentés</p>
                            </div>

                            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                                <div className="text-[#d2ab6a] w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                                    <Star className="w-full h-full" />
                                </div>
                                <div className="text-4xl font-bold text-[#d2ab6a] mb-2">100%</div>
                                <p className="text-white/70">Africains</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* --- CTA vers les Distinctions --- */}
                <section className="py-20">
                    <div className="container mx-auto px-4 text-center">
                        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                            Découvrez nos <span className="text-[#d2ab6a]">Distinctions</span>
                        </h2>
                        <p className="text-white/80 max-w-2xl mx-auto mb-8">
                            Explorez le catalogue complet de nos distinctions et rejoignez le cercle des lauréats de demain.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Link
                                to="/nos-distinctions"
                                className="bg-[#d2ab6a] text-[#0d1321] hover:bg-[#c19b59] inline-flex items-center justify-center space-x-2 px-8 py-4 text-lg font-bold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                <span>Voir les Distinctions</span>
                                <Award className="w-5 h-5" />
                            </Link>
                            <Link
                                to="/contact"
                                className="border-2 border-[#d2ab6a] text-[#d2ab6a] hover:bg-[#d2ab6a] hover:text-white inline-flex items-center justify-center space-x-2 px-8 py-4 text-lg font-bold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                <span>Nous Contacter</span>
                                <Medal className="w-5 h-5" />
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </PublicLayout>
    );
};

export default LaureatsPage;
